'use client';

import { useEffect } from 'react';

export default function ContactUsForm() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://link.mayesautodetailing.com/js/form_embed.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div className="mx-auto w-full max-w-4xl px-4 py-8">
      <h2 className="text-secondary mb-6 text-center font-bold">
        Get in Touch
      </h2>
      <div className="h-[700px] overflow-hidden">
        <iframe
          id="contact-us-form"
          name="contact-us-form"
          src="https://link.mayesautodetailing.com/widget/form/BD5cFXdcZJroz9IOsZHk"
          className="h-full w-full"
          style={{ width: '100%', height: '100%', border: 'none' }}
          data-layout='{"id":"INLINE"}'
          data-trigger-type="alwaysShow"
          data-trigger-value=""
          data-activation-type="alwaysActivated"
          data-activation-value=""
          data-deactivation-type="neverDeactivate"
          data-deactivation-value=""
          data-form-name="Contact Us Form"
          data-height="696"
          data-layout-iframe-id="inline-BD5cFXdcZJroz9IOsZHk"
          data-form-id="BD5cFXdcZJroz9IOsZHk"
          title="Contact Us Form"
        />
      </div>
    </div>
  );
}
